
import req from '@/utils/request'
import auth from '@/models/auth.js'

const getDefaultState = () => {
  return {
    token: auth.gettoken(),
    name: '',
    userType: 0, // 3为租户  4为集团
    tenantId: '',
    application:{},//租户应用信息
    titles:''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    state.token = null
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERTYPE: (state, userType) => {
    state.userType = userType
  },
  SET_TENANTID: (state, tenantId) => {
    state.tenantId = tenantId
  },
  APP_LICATION: (state, application) => {
    state.application = application
  },
  TITLES(state, title){
    state.titles = title
  }
}

const actions = {
  setToken({ commit }, form) {
    auth.save(form)
    commit('SET_TOKEN', form)
  },

  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      req.get('/ha-base/user/info').then(response => {
        const { data } = response

        if (!data) {
          return reject('认证失败，请重新授权')
        }

        const { name, roleId, userType, tenantId } = data

        commit('SET_NAME', name)
        commit('SET_ROLEID', roleId)// 角色类型
        commit('SET_USERTYPE', userType)
        commit('SET_TENANTID', tenantId)

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit }) {
    auth.clean()
    commit('RESET_STATE')
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

